import styled from "styled-components";

export const TeamManagementContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .content_section {
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    min-height: calc(100vh - 235px);
    border-radius: 8px;
    padding: 24px 32px;
  }

  .loading_wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 400px;
  }

  .header_block {
    margin-bottom: 24px;
  }

  .mission_info_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .code_label {
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
      margin-right: 8px;
    }

    .code_value {
      font-size: ${({ theme }) => theme.FONT.SIZE.S20};
      font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }

    .status_area {
      display: flex;
      align-items: center;
      gap: 8px;

      .status_label {
        font-size: 14px;
        font-weight: 500;
        color: ${({ theme }) => theme.COLORS.GRAY_4};
      }
    }
  }

  .mission_fields_row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-bottom: 28px;
  }

  .team_section_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .team_section_title {
      font-size: ${({ theme }) => theme.FONT.SIZE.S20};
      font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
    }

    .team_summary {
      font-size: ${({ theme }) => theme.FONT.SIZE.S20};
      color: ${({ theme }) => theme.COLORS.GRAY_23};
      display: flex;
      align-items: center;
      gap: 8px;

      .team_summary_number {
        font-size: ${({ theme }) => theme.FONT.SIZE.S20};
        font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
        .team_summary_separator{
            color: ${({ theme }) => theme.COLORS.GRAY_30};
        }
    }
  }

  .table_section {
    margin-bottom: 0;
  }

  .member_cell {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 45%;

    .progress_wrap {
      flex: 1;
      min-width: 80px;
    }

    .member_count_text {
      font-size: 12px;
      color: ${({ theme }) => theme.COLORS.GRAY_26};
      white-space: nowrap;

      .member_count_value {
        font-size: 14px;
        font-weight: 600;
        color: ${({ theme }) => theme.COLORS.GRAY_23};
      }
    }
  }

  .pagination_section {
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    border-radius: 8px;
  }
`;
